export default {
    app: {
        apiUrl: 'http://localhost:8080/api',
        reportsApiUrl: 'http://localhost:8480/api',
        dataCollectionApiUrl: 'http://localhost:8081/api',
        modulesHostApiUrl: 'http://localhost:8084/api',
        openStreetApiUrl: 'https://nominatim.openstreetmap.org/',
    },
    dataCollection: {
        maxIntervalMinutes: 60,
        minIntervalMinutes: 5,
        stepMinutes: 5,
    },
    upload: {
        supportedImageTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'], // webp is added
    },
    image: {
        authBackground: 'bg-5',
    },
    durations: {
        notification: 4.5,
        searchDelay: 500,
    },
    dates: {
        minYearDate: 1970,
    },
    logs: {
        isDebug: true,
        logLevel: 'trace',
        antdWarningsEnabled: true,
    },
};
